import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for /setup/departments/:id/* — exists so View (index) and Edit can both
// nest under a common parent. No shared chrome; just renders the matched child.
export const Route = createFileRoute('/_authenticated/setup/departments/$id')({
  component: () => <Outlet />,
});
